import { Component, Inject } from '@angular/core'
import { MatCard } from '@angular/material/card'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogClose,
} from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  selector: 'dialog-loading',
  imports: [MatCard, MatDialogClose, MatIcon, MatButton, MatProgressSpinner],
  templateUrl: './dialog-loading.component.html',
  styleUrl: './dialog-loading.component.scss',
})
export class DialogLoadingComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
